//  Forms
import {
  inputReporterType,
  inputFirstName,
  inputLastName,
  inputRelationshipToPatient,
  inputPostcode,
  inputDateOfBirth,
  inputProblemDescription,
  inputProblemRecentContact,
  inputAdminRequest,
  inputVerificationCode,
  inputAttachments,
  inputConfirmCancellation,
  inputReasonForAppointment,
  inputReplyMessage,
} from '../inputs';

// forms that use inputs
export const formReporterType = {
  config: {},
  fields: [inputReporterType],
};

export const formYourDetails = {
  config: {
    formTitle: 'Please fill in your details',
    hint: 'We use these details to contact you about this request.',
  },
  fields: [inputFirstName, inputLastName, inputRelationshipToPatient],
};

//  slight variation depend if user is patient or 'someone else'
export const formPatientDetailsYou = {
  config: {
    formTitle: 'Please fill in your details',
    hint: 'We use these details to find your patient record.',
  },
  fields: [inputFirstName, inputLastName, inputPostcode, inputDateOfBirth],
};

// slight variation depends if user is patient or 'someone else'
// NB, spread object first then add overrides
export const formPatientDetailsProxy = {
  ...formPatientDetailsYou,
  config: {
    formTitle: "Please fill in the patient's details",
    hint: 'We use these details to find their patient record.',
  },
};

export const formPatientProblemDetails = {
  config: {},
  fields: [inputProblemDescription, inputProblemRecentContact, inputAttachments],
};

export const formAdminRequestDetails = {
  fields: [inputAdminRequest, inputAttachments],
};

// ENG-21799 The questionnaire link's own challenge, with its own endpoint. No
// formTitle — the layout already renders the route's title as the page h1.
export const formQuestionnaireIdentity = {
  config: {
    hint: 'We need to check who you are before showing you this questionnaire.',
  },
  fields: [inputFirstName, inputLastName, inputPostcode, inputDateOfBirth],
};

export const formVerificationCode = {
  config: {
    formTitle: 'Verification Code Sent',
    hint: 'We have sent a verification code to your email address or mobile phone.',
  },
  fields: [inputVerificationCode],
};

// ENG-21800 Appointments.
export const formAppointmentCancellationConfirm = {
  config: {},
  fields: [inputConfirmCancellation],
};

export const formAppointmentReason = {
  config: {},
  fields: [inputReasonForAppointment],
};

export const formVerifyDateOfBirth = {
  config: {
    hint: 'We ask for this to check the message is being opened by the right person.',
  },
  fields: [inputDateOfBirth],
};

export const formMessageReply = {
  config: {},
  fields: [inputReplyMessage, inputAttachments],
};
